var playSpeed = 41*1;
